import { Directive, ElementRef, Input, HostListener } from '@angular/core';

import { PdfSelectionService } from '../../pdf-assigner-module/core/services/pdf-selection.service';
import { LaunchersService } from '../services/http-services/launchers.service';
import { ManageSystemSelectionServiceService } from '../services/http-services/manage-system-selection-service.service';
import { ScreensStateService } from '../services/screen-state/screens-state.service';
import { UIService } from '../services/utils/ui.service';
import { MonitorMenuService } from '../services/dialog-services/monitor-menu.service';

@Directive({
  selector: '[clickOutside]',
})
export class ClickOutsideDirective {
  constructor(
    private readonly _elementRef: ElementRef,
    private readonly screenStateService: ScreensStateService,
    private readonly uiService: UIService,
    private readonly pdfSelectionService: PdfSelectionService,
    private readonly manageSystemSelectionServiceService: ManageSystemSelectionServiceService,
    private readonly launcherService: LaunchersService,
    private readonly monitorMenuService: MonitorMenuService
  ) { }

  @Input('parentComponent') parentComponent: any;
  @Input('clickOutside') clickOutside: any[];
  @Input('isToChangeFocus') isToChangeFocus: any;

  @HostListener('document:touchstart', ['$event'])
  @HostListener('document:click', ['$event'])
  public onClickOutside(event: MouseEvent): void {
    if (!this.clickOutside.length) {
      if (
        !this._elementRef.nativeElement.contains(event.target) &&
        this.parentComponent && this.parentComponent.contains(event.target) &&
        !this.monitorMenuService.monitorContextMenuInstance?.componentInstance
      ) {
        this.parentComponent.focus();
        this.screenStateService.unselectAll();
        this.uiService.hideBottomPanel();
        this.uiService.ADBDeviceSelectionChanged.next();
        this.pdfSelectionService.unselectAll();
        this.manageSystemSelectionServiceService.unselectAll();
        this.launcherService.hideMawChromeSettings.next();
        this.uiService.unselectAllPlaylistItems.next();
      }
    }

    if (this.isToChangeFocus && this._elementRef.nativeElement !== event.target) {
      this._elementRef.nativeElement.blur();
    }
  }
}
